import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './styles/index.css';

// 🟢 [P2] React Query：前端请求缓存，减少重复 Firestore 读取与页面闪烁
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 1 分钟内视为新鲜，切回页面直接用缓存不重新请求
      gcTime: 5 * 60 * 1000, // 缓存保留 5 分钟
      refetchOnWindowFocus: false, // 切窗口不自动重拉，避免无谓请求
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <HashRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App />
      </HashRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
